export default __webpack_public_path__ + "static/media/Extrusion-Vendors.ad1fa98d.jpg";